import { jsxs as l, jsx as o } from "react/jsx-runtime";
import { useState as H, useRef as E, useEffect as J } from "react";
import { u as i } from "./index-6a632112.mjs";
import { s as n, Q as g, r as k, b as m, k as $, e as h, c as M } from "./themes-5f0b3c3d.mjs";
import { t } from "./textStyles-42cab346.mjs";
import { Button as R } from "./button.js";
import { S as N } from "./edit-054ba80e.mjs";
import { S as A } from "./warningFilled-691cfde1.mjs";
import { useAccessibilityProps as f } from "./accessibility.js";
import { u as V } from "./uniqueId-321287e8.mjs";
import "./lineHeights-72d3110c.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./types-b577bf77.mjs";
const Y = i.div`
  display: inline-flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
`, Z = i.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`, ee = i.div`
  display: flex;
  ${(e) => e.$error && `margin-bottom: ${n["2x"]}`};
  column-gap: ${({ $inputSize: e }) => e === "small" ? n["3x"] : n["4x"]};
  flex-direction: column;
  @media ${g.tabletAndUp} {
    flex-direction: row;
  }
`, ne = i.div`
  display: inline-flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  height: ${(e) => e.$inputSize === "large" ? n["12x"] : e.$inputSize === "medium" ? n["10x"] : n["8x"]};

  padding: ${(e) => e.$inputSize === "large" ? `0px ${n["3x"]} 0px ${n["3x"]}` : e.$inputSize === "medium" ? `0px ${n["3x"]} 0px ${n["3x"]}` : `0px ${n["2x"]} 0px ${n["2x"]}`};
  border-radius: ${k["1x"]};
  &:hover {
    ${(e) => !e.$isDisabled && `cursor: pointer;
    background-color: ${e.theme.components.inLineText.hoverBackgroundColor};`}
  }

  &:focus-visible {
    outline: ${m["2x"]} solid
      ${(e) => e.theme.components.inLineText.focusRingColor};
  }
`, ie = i.input`
  height: ${(e) => e.$inputSize === "large" ? n["12x"] : e.$inputSize === "medium" ? n["10x"] : n["8x"]};
  width: 100%;
  box-sizing: border-box;
  padding-left: ${(e) => e.$inputSize === "small" ? n["2x"] : n["3x"]};
  border: unset;
  padding: ${n["1x"]} ${n["2x"]};
  border-radius: ${k["1x"]};
  border: ${m["1x"]} solid
    ${(e) => e.$error ? e.theme.components.inLineText.errorRingColor : e.theme.components.inLineText.inactiveRingColor};
  font-family: ${$};
  font-size: ${(e) => e.$inputSize === "large" ? t.body.medium.l.fontSize : e.$inputSize === "medium" ? t.body.medium.m.fontSize : t.body.medium.s.fontSize};
  font-weight: ${h.regular.L.fontWeight};
  color: ${(e) => e.theme.components.inLineText.fontColor};
  background-color: ${(e) => e.theme.components.inLineText.openBackgroundColor};

  &::placeholder {
    font-family: ${$};
    font-size: ${(e) => e.$inputSize === "large" ? t.body.medium.l.fontSize : e.$inputSize === "medium" ? t.body.medium.m.fontSize : t.body.medium.s.fontSize};
    font-weight: ${h.regular.L.fontWeight};
  }

  &:hover {
    ${(e) => !e.$error && `border: ${m["1x"]} solid ${e.theme.components.inLineText.activeRingColor}`};
  }

  &:focus {
    ${(e) => !e.$error && `outline: ${m["1x"]} solid ${e.theme.components.inLineText.activeRingColor};
      border: ${m["1x"]} solid ${e.theme.components.inLineText.activeRingColor}`};
    ${(e) => e.$error && `outline: ${m["1x"]} solid ${e.theme.components.inLineText.errorRingColor};
      border: ${m["1x"]} solid ${e.theme.components.inLineText.errorRingColor}`};
  }
`, te = i.span`
  display: inline-flex;
  white-space: nowrap;
  margin-right: ${n["2x"]};
  font-family: ${$};
  font-size: ${(e) => e.$inputSize === "large" ? t.body.medium.l.fontSize : e.$inputSize === "medium" ? t.body.medium.m.fontSize : t.body.medium.s.fontSize};
  font-weight: ${h.semiBold.M.fontWeight};
  color: ${(e) => e.$isDisabled ? e.theme.components.inLineText.disabledFontColor : e.theme.components.inLineText.fontColor};
`, oe = i.div`
  display: inline-flex;
`, re = i.span`
  display: inline-flex;
  color: ${(e) => e.$isDisabled ? e.theme.components.inLineText.disabledIconColor : e.theme.components.inLineText.iconColor};
`, le = i.label`
  display: flex;
  font-family: ${$};
  font-size: ${t.body.medium.s.fontSize};
  font-weight: ${h.medium.S.fontWeight};
  color: ${(e) => e.theme.components.inLineText.fontColor};
  margin-bottom: ${n["2x"]};
`, F = i.div`
  display: none;
  @media ${g.tabletAndUp} {
    display: flex;
    align-items: center;
    color: ${(e) => e.theme.components.inLineText.errorTextColor};
    font-family: ${$};
    font-size: ${t.body.medium.s.fontSize};
  }
`, D = i.span`
  ${(e) => e.$showErrorIcon && `margin-left: ${n["2x"]}`};
`, ae = i.div`
  display: flex;
  gap: ${({ $inputSize: e }) => e === "small" ? n["2x"] : e === "medium" ? n["3x"] : n["4x"]};
  margin-top: ${n["3x"]};
  @media ${g.tabletAndUp} {
    margin: unset;
  }
`, de = i(F)`
  display: block;
  color: ${(e) => e.theme.components.inLineText.errorTextColor};
  font-family: ${$};
  font-size: ${t.body.medium.s.fontSize};
  margin-top: ${n["2x"]};
  @media ${g.tabletAndUp} {
    display: none;
  }
`, me = "inline-text", ze = ({
  size: e = "large",
  value: b,
  placeholder: y,
  label: u,
  isDisabled: r = !1,
  errorMessage: c,
  showErrorIcon: x = !1,
  isOpen: U = !1,
  isRequired: L = !1,
  showRequiredIndicator: K = L,
  onClickOpen: z,
  onClickSave: v,
  onClickCancel: C,
  onTextChange: T,
  accessibilityOptions: a = {},
  onBlur: O
}) => {
  const [s, S] = H(U), p = E(null), w = E(V(me)), I = () => {
    v && v(), S(!s);
  }, j = (d) => {
    T && T(d.target.value);
  }, P = (d) => {
    d.code === "Escape" ? B() : d.code === "Enter" && I();
  }, W = () => {
    z && z(), S(!s);
  };
  J(() => {
    p?.current && p.current?.focus();
  }, [s]);
  const Q = (d) => {
    (d.code === "Enter" || d.code === "Space") && W();
  }, B = () => {
    C && C(), S(!s);
  }, q = f("button", {
    ariaLabel: a?.component?.ariaLabel || `Edit ${u}`,
    ...a?.component,
    tabIndex: 0,
    ariaDisabled: r
  }), X = f("button", {
    ariaLabel: a?.saveButton?.ariaLabel || "Save",
    ...a?.saveButton,
    tabIndex: 0,
    ariaDisabled: r
  }), _ = f("button", {
    ariaLabel: a?.cancelButton?.ariaLabel || "Cancel",
    ...a?.cancelButton,
    tabIndex: 0,
    ariaDisabled: r
  }), G = f("input", {
    ariaLabel: a?.input?.ariaLabel || u,
    ...a?.input,
    tabIndex: r ? -1 : 0,
    ariaDisabled: r
  });
  return /* @__PURE__ */ l(Y, { children: [
    /* @__PURE__ */ l(le, { htmlFor: w.current, children: [
      u,
      u && K && /* @__PURE__ */ l(
        "span",
        {
          "aria-hidden": "true",
          style: { color: M.utilityDanger[1e3] },
          children: [
            " ",
            "*"
          ]
        }
      )
    ] }),
    s ? /* @__PURE__ */ l(Z, { children: [
      /* @__PURE__ */ l(ee, { $error: !!c, $inputSize: e, children: [
        /* @__PURE__ */ o(
          ie,
          {
            id: w.current,
            ref: p,
            value: b,
            placeholder: y,
            $inputSize: e,
            $error: !!c,
            onChange: j,
            "aria-label": "input",
            "aria-required": L,
            onKeyDown: P,
            onBlur: O,
            ...G
          }
        ),
        c && /* @__PURE__ */ l(de, { children: [
          x && /* @__PURE__ */ o(A, { "aria-label": "warning", height: "20px", width: "20px" }),
          /* @__PURE__ */ o(
            D,
            {
              $showErrorIcon: x,
              "aria-live": "polite",
              role: "alert",
              children: c
            }
          )
        ] }),
        /* @__PURE__ */ l(ae, { $inputSize: e, children: [
          /* @__PURE__ */ o(oe, { $inputSize: e, children: /* @__PURE__ */ o(
            R,
            {
              onClick: I,
              size: e,
              ...X,
              children: "Save"
            }
          ) }),
          /* @__PURE__ */ o(
            R,
            {
              size: e,
              variant: "outline",
              onClick: B,
              ..._,
              children: "Cancel"
            }
          )
        ] })
      ] }),
      c && /* @__PURE__ */ l(F, { children: [
        x && /* @__PURE__ */ o(A, { "aria-label": "warning", height: "20px", width: "20px" }),
        /* @__PURE__ */ o(
          D,
          {
            $showErrorIcon: x,
            "aria-live": "polite",
            role: "alert",
            children: c
          }
        )
      ] })
    ] }) : /* @__PURE__ */ l(
      ne,
      {
        $inputSize: e,
        $isDisabled: r,
        ...!r && {
          onClick: W,
          onKeyDown: Q
        },
        ref: p,
        ...q,
        children: [
          /* @__PURE__ */ o(te, { $inputSize: e, $isDisabled: r, children: b || y }),
          !s && /* @__PURE__ */ o(re, { $isDisabled: r, children: /* @__PURE__ */ o(N, { height: "20px", width: "20px" }) })
        ]
      }
    )
  ] });
};
export {
  ze as InLineText
};
